import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { getCategories } from "@/lib/news";

const navItems = [
  { label: "首页", to: "/" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const categories = getCategories();
  const [keyword, setKeyword] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCategoryOpen, setMobileCategoryOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
    setMobileOpen(false);
  };

  const today = new Date();
  const dateLabel = `${today.getFullYear()}年${today.getMonth() + 1}月${today.getDate()}日`;

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 顶部信息条 */}
      <div className="w-full bg-primary-950 text-background-100">
        <div className="mx-auto flex h-9 max-w-[1280px] items-center justify-between px-4 md:px-6 text-xs">
          <span className="flex items-center gap-2 text-background-300">
            <i className="ri-calendar-line"></i>
            {dateLabel}
          </span>
          <span className="hidden items-center gap-2 text-accent-400 sm:flex">
            <i className="ri-fire-line"></i>
            独家爆料 · 实时更新 · 直击内幕
          </span>
          <span className="flex items-center gap-4 text-background-300">
            <span className="hidden items-center gap-1 sm:flex">
              <i className="ri-user-3-line"></i>访客浏览
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-shield-check-line"></i>内容均为演示
            </span>
          </span>
        </div>
      </div>

      {/* 主导航 */}
      <div className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1280px] items-center gap-4 px-4 md:px-6">
          <Link to="/" className="flex shrink-0 items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-xl"></i>
            </span>
            <span className="font-heading text-xl font-black tracking-tight">
              <span className="text-accent-500">91</span>
              <span className="text-primary-700">爆料</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `relative rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  isActive ? "text-primary-600" : "text-foreground-700 hover:text-primary-600"
                }`
              }
            >
              首页
            </NavLink>

            <div className="relative" ref={dropdownRef}>
              <button
                type="button"
                onClick={() => setDropdownOpen((v) => !v)}
                className={`flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  dropdownOpen ? "text-primary-600" : "text-foreground-700 hover:text-primary-600"
                }`}
              >
                分类
                <i className={`ri-arrow-down-s-line transition-transform ${dropdownOpen ? "rotate-180" : ""}`}></i>
              </button>
              {dropdownOpen && (
                <div className="absolute left-0 top-full mt-2 w-[420px] rounded-lg border border-background-200 bg-background-50 p-3">
                  <div className="grid grid-cols-2 gap-1">
                    {categories.map((cat) => (
                      <Link
                        key={cat.key}
                        to={`/category/${cat.key}`}
                        onClick={() => setDropdownOpen(false)}
                        className="group flex items-start gap-3 rounded-md px-3 py-2 transition-colors hover:bg-primary-50"
                      >
                        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
                          <i className="ri-article-line"></i>
                        </span>
                        <span>
                          <span className="block text-sm font-semibold text-foreground-900">{cat.name}</span>
                          <span className="block text-xs text-foreground-500">点击查看{cat.name}新闻</span>
                        </span>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {navItems.slice(1).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                    isActive ? "text-primary-600" : "text-foreground-700 hover:text-primary-600"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={submitSearch} className="ml-auto hidden max-w-xs flex-1 lg:block">
            <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 transition-colors focus-within:border-primary-400">
              <i className="ri-search-line text-sm text-foreground-400"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="search"
                placeholder="搜索热点新闻、爆料关键词"
                className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
              <button
                type="submit"
                className="shrink-0 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                搜索
              </button>
            </div>
          </form>

          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="打开菜单"
            className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {mobileOpen && (
        <div className="border-b border-background-200 bg-background-50 md:hidden">
          <div className="mx-auto max-w-[1280px] space-y-3 px-4 py-4">
            <form onSubmit={submitSearch}>
              <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2">
                <i className="ri-search-line text-sm text-foreground-400"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  type="search"
                  placeholder="搜索热点新闻、爆料关键词"
                  className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
                />
              </div>
            </form>
            <div className="flex flex-col">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMobileOpen(false)}
                  className="border-b border-background-200 py-3 text-sm font-medium text-foreground-800"
                >
                  {item.label}
                </Link>
              ))}
              <button
                type="button"
                onClick={() => setMobileCategoryOpen((v) => !v)}
                className="flex cursor-pointer items-center justify-between border-b border-background-200 py-3 text-sm font-medium text-foreground-800"
              >
                <span>新闻分类</span>
                <i className={`ri-arrow-down-s-line transition-transform ${mobileCategoryOpen ? "rotate-180" : ""}`}></i>
              </button>
              {mobileCategoryOpen && (
                <div className="flex flex-wrap gap-2 py-3">
                  {categories.map((cat) => (
                    <Link
                      key={cat.key}
                      to={`/category/${cat.key}`}
                      onClick={() => setMobileOpen(false)}
                      className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}